define(function (require) {
    'use strict';

    var Marionette = require('marionette');
    var popover = require('behaviors/popover');
    var modal = require('behaviors/modal');
    var Backbone = require('backbone');
    var _ = require('underscore');
    var $ = require('jquery');
    var mainTpl = require('text!tmpls/parts/caller_left/main.tpl').default;
    var itemTpl = require('text!tmpls/parts/caller_left/item.tpl').default;
    var itemNoRes = require('text!tmpls/parts/caller_left/no_res.tpl').default;
    var SmsEditPopover = require('popovers/sms_edit/view');
    var ContactCollection = require('collections/contacts');
    var ContactModel = require('models/contacts');
    var contactsCollection = new ContactCollection();
    var AppConfig = require('config/application');
    var ItemNoResult = Marionette.ItemView.extend({template: itemNoRes});
    var loader = require('text!tmpls/loader.tpl').default;
    require('components/phoneinput/phoneinput');

    var LoaderView = Marionette.ItemView.extend({
        className: 'loader-wrapper caller-loader-wrapper',
        template: loader
    });

    var ItemContact = Marionette.ItemView.extend({
        template: itemTpl,
        model: new ContactModel()
    });

    var Model = Backbone.Model.extend({
        search: true
    });

    return Marionette.LayoutView.extend({
        template: mainTpl,
        className: 'b-caller',
        model: new Model(),
        regions: {
            regionContacts: '#b-caller-letters-block'
        },

        ui: {
            'openContact': '.js-caller-open-contact',
            'cleanInputSearch': '.js-caller-clean-search',
            'cleanInputCall': '.js-caller-clean-call',
            'clickPhone': '.js-caller-phone',
            'inputPhone': 'input[name=phone]',
            'inputName': '.js-call_input_name',
            'call_btn_sip': '.call_btn_sip',
            'call_btn_sim': '.call_btn_sim',
            'call_btn_mobile': '.call_btn_mobile',
            'btnSendSms': '.btn_send_sms',
            'scroller': '.js-scroller'
        },

        events: {
            'click @ui.openContact': 'openContact',
            'click @ui.cleanInputSearch': 'cleanInputSearch',
            'click @ui.clickPhone': 'clickPhone',
            'click @ui.cleanInputCall': 'cleanInputCall',
            'click @ui.call_btn_mobile': 'do_call_mobile',
            'click @ui.call_btn_sip': 'do_call_sip',
            'click @ui.call_btn_sim': 'do_call_sim',
            'click @ui.btnSendSms': 'sendSms'
        },

        parentBehaviors: {
            'popover': {behaviorClass: popover},
            'modal': {behaviorClass: modal}
        },

        newBehaviors: {},

        firstScrollInit: true,

        behaviors: function () {
            return _.extend({}, this.parentBehaviors, this.newBehaviors);
        },

        initialize: function () {
            var that = this;

            that.$el.on('keydown', '.js-call_input_name', _.debounce(that.searchByName.bind(that), 500));
            that.$el.on('keydown', '#js-call_to_phone', _.debounce(that.searchByPhone.bind(that), 500));

            app.Collections.contacts = new ContactCollection();
            that.listenTo(app.Collections.contacts, 'add', that.addedContact);
            contactsCollection = app.Collections.contacts;
            that.listenToOnce(contactsCollection, 'sync', function (data) {
                that.afterRender();
                that.collectionToArray();
            });
            contactsCollection.fetch();
        },

        addedContact: function () {
            // contactsCollection = app.Collections.contacts;
            // this.collectionToArray();
        },

        onRender: function () {
            this.regionContacts.show(new LoaderView());
            this.binding = app.Rivets.bind(this.el, {model: this.model});
        },

        // validation to phone
        afterRender: function () {
            //this.ui.inputPhone.inputmasks(app.phone_mask_config);
            $(this.ui.inputPhone).phoneinput();
        },

        /*
         * создание модели
         * для вывода букв
         */
        collectionToArray: function () {
            var that = this, first_letter, total, phones = [], item = {};

            _.each(contactsCollection.models, function (model, i) {
                first_letter = model.get('name').charAt(0).toUpperCase();
                phones = $.map(model.get('phones'), function (value, index) {
                    return [value];
                });

                total = model.get('total');

                if (typeof item[first_letter] == 'undefined') item[first_letter] = [];

                item[first_letter].push({
                    name: model.get('name'),
                    phones: phones,
                    id: model.id
                });
            });

            var overLength = false;
            if (contactsCollection.models.length < total) {
                overLength = true;
            }

            that.model.set({
                item: item,
                overLength: overLength
            });
            that.showContacts();

        },

        showContacts: function () {
            var that = this;
            this.$el.lptSetter();
            this.regionContacts.show(new ItemContact({model: this.model}));
            this.$('.js-search').show();

            if (this.firstScrollInit) {
                setTimeout(function () {
                    var styles = "overflow-x:hidden !important; max-height:" + $('.b-caller__contacts_block.js-scroller').outerHeight() + "px",
                        $scroller = that.$('.js-scroller'),
                        isFirefoxOnMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0 && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
                    if (isFirefoxOnMac) {
                        app.States.isFirefoxOnMac = true;
                        styles += 'overflow-y:scroll !important;';
                    } else {
                        app.States.isFirefoxOnMac = false;
                    }
                    $scroller.prop('style', styles);
                    that.firstScrollInit = false;
                }, 1000);
            }
        },

        openContact: function (e) {
            var current = $(e.currentTarget);
            if (current.hasClass('b-caller__letter_passive')) {
                current.removeClass('b-caller__letter_passive').addClass('b-caller__letter_active');
                current.next('div').slideDown(400);
            }
            else {
                current.removeClass('b-caller__letter_active').addClass('b-caller__letter_passive');
                current.next('div').slideUp(400);
            }
        },

        cleanInputSearch: function (e) {
            if ($(e.currentTarget).prev().val() != '') {
                $(e.currentTarget).prev().val('');
                var self = this;
                app.Collections.contacts.fetch({
                    success: function () {
                        if(self.isDestroyed) {
                            return;
                        }
                        contactsCollection = app.Collections.contacts;
                        if (contactsCollection.length > 0) {
                            self.collectionToArray();
                        } else {
                            self.regionContacts.show(new ItemNoResult());
                        }
                        window.searchContactsWait = false;
                    }
                });
            }
        },

        cleanInputCall: function (e) {
            this.ui.inputPhone.val('');
            this.searchContacts();
        },

        clickPhone: function (e) {
            var number = $(e.currentTarget).text();
            var id = $(e.currentTarget).data('id');
            this.$('.b-caller__input').val(number);
            this.$('.b-caller__input').data('contact_id', id);
        },

        searchByName: function() {
            var search = this.ui.inputName.val();
            this.ui.inputPhone.val('');
            this.searchContacts({query: search})
        },

        searchByPhone: function() {
            var search = this.ui.inputPhone.val();
            this.model.set('search', '');
            this.searchContacts({phone: search})
        },

        searchContacts: function (data) {
            var self = this;
            data = data || {};
            //@CRUTCH
            //Тут можно в общем то и без костыля с window, но это позволяет не делать запрос после каждого нажатия
            //if (window.searchContactsWait) {
            //    clearTimeout(window.searchContactsTimeout)
            //}
            //window.searchContactsWait = true;
            //window.searchContactsTimeout = setTimeout(function () {
                app.Collections.contacts.fetch({
                    data: data,
                    success: function () {
                        if(self.isDestroyed) {
                            return
                        }
                        contactsCollection = app.Collections.contacts;
                        if (contactsCollection.length > 0) {
                            self.collectionToArray();
                        } else {
                            self.regionContacts.show(new ItemNoResult());
                        }
                        //window.searchContactsWait = false;
                    }
                });
            //}, 600);
        },

        sendSms: function(event) {
            var that = this;
            var target = event.target;
            var input = $('#js-call_to_phone');
            event.stopPropagation();
            this.triggerMethod('showPopover', {
                view: SmsEditPopover,
                target: target,
                handler: function(popover) {
                    that.listenToOnce(popover, 'sms:edited', function(message) {
                        var data = {
                            to: input.val(),
                            text: message
                        };
                        if(data.to.length) {
                            var msg = app.message.success('Отправка Sms', false);
                            that._xhr = Backbone.ajax({
                                url: AppConfig.host + '/rest/contacts/sms',
                                contentType: 'application/json',
                                type: 'POST',
                                data: JSON.stringify(data),
                                success: function (data) {
                                    msg.hide();
                                },
                                error: function (xhr) {
                                    var data = xhr.responseJSON;
                                    app.message.error(data.message);
                                }
                            });
                        } else {
                            app.message.error('Нет выбранных номеров');
                        }
                    })
                }
            });
        },

        do_call_sip: function (event) {
            this.do_call({type: 'sip'});
        },

        do_call_sim: function (event) {
            this.do_call({type: 'sim'});
        },

        do_call_mobile: function (event) {
            this.do_call({type: 'mobile'});
        },

        do_call: function (options) {
            var that = this;
            var input = $('#js-call_to_phone');
            /**
             * @type {string}
             */
            var phone = $(input).val();
            var id = $(input).data('contact_id');
            var call_type = options.type;

            var byContact = phone.indexOf('*') != -1 && id > 0;

            var method = byContact ? 'call' : 'call_to_number';
            var data = {
                call_type: call_type
            };

            if (byContact) {
                data.phone_id = id;
            } else {
                data.phone = phone;
            }

            Backbone.ajax({
                type: 'POST',
                url: AppConfig.host + '/rest/contacts/' + method,
                contentType: 'application/json',
                data: JSON.stringify(data),
                success: function (response) {
                    if (response.status == AppConfig.STATUS_OK) {
                        app.message.success(response.message);
                    } else {
                        app.message.error(response.message);
                    }
                },
                error: function (xhr) {
                    var response = $.parseJSON(xhr.responseText);
                    app.message.error(response.message || 'Ошибка');
                }
            })
        },

        onDestroy: function () {
            this.model.off('change:search', this.searchContacts, this);
            app.Collections.contacts.off('add', this.addedContact, this);
            this.off('render', this.afterRender, this);
        }
    });

});
